import { checkAsylumStatus } from './helpers'

export const loggedIn = state => state.loggedIn
export const hasPermissionUserEmailBatches = state =>
  state.permissions.includes('user_message_batches')
export const hasPermissionUnlimitedSearch = state =>
  state.permissions.includes('unlimited_search')

export const educations = state => state.query.educations

export const hasWorkPermitChecked = state => {
  const valid = {
    hasAtUnd: true
  }

  return !!checkAsylumStatus(state, valid, 'hasAtUnd')
}

export const hasResidencePermitChecked = state => {
  const valid = {
    hasResidencePermit: true
  }

  return !!checkAsylumStatus(state, valid, 'hasResidencePermit')
}

export const noWorkPermitChecked = state => {
  const valid = {
    hasAtUnd: false
  }

  return !!checkAsylumStatus(state, valid, 'hasAtUnd')
}

export const hasLanguage = state => language => {
  return !!state.query.languages.find(l => l.name === language)
}

export const hasError = state => {
 return !!state.error
} 

export const hasDuplicateTag = state => name => {
  return (
    !!state.query.experiences.find(e => e.name === name) &&
    !!state.query.skills.find(s => s.name === name)
  )
}

export const getQueryType = state => type => {
  const selected = state.query[type]
  return selected ? selected.length : 0
}

export const getSelectedFromQuery = state => types => {
  return Object.keys(state.query).reduce((acc, type) => {
    if (types.includes(type)) {
      return {
        ...acc,
        [type]: state.query[type]
      }
    }

    return acc
  }, {})
}

export const hasValue = state => (path, type) => {
  return !!state.query[type].find(
    item => item.path === path.replace('county-', '')
  )
}

export const currentModal = state => {
  return state.modal
}



// WEBPACK FOOTER //
// ./src/store/getters.js